import React, {useState} from "react";

//Ant design imports
import { ConfigProvider, Select } from "antd";
import {
  CheckOutlined,
  CloseOutlined,
  WarningOutlined,
} from "@ant-design/icons";

//project imports
import appStatic from "../config/appStatic";

const StatusSelect = (props) => {
  const { listStatusData } = appStatic;
  const { handleStatusChange, colorText } = props;
  const [isActive, setIsActive] = useState(true);
  const [authSelectColour, setAuthSelectColor] = useState("transparent");

  const iconMap = {
    Active: <CheckOutlined />,
    Unauthorised: <CloseOutlined />,
    Disabled: <WarningOutlined />,
  };

  const renderOption = (label) => (
    <span>
      {iconMap[label]} {label}
    </span>
  );

  function onSelect(value) {
    switch (value.toLowerCase()) {
      case 'active':
        setIsActive(true);
        return setAuthSelectColor("transparent");
      case 'disabled':
        setIsActive(false);
        return setAuthSelectColor("#ed5565");
      default:
        setIsActive(false);
        return setAuthSelectColor("#fff");
    }
  }

  return (
    <div className={isActive ? "status-select-active" : ""}>
      <ConfigProvider
        theme={{
          token: {
            colorBgContainer: authSelectColour,
            colorText: colorText,
          },
        }}
      >
        <Select
          defaultValue={listStatusData[0].value}
          prefixCls="test"
          options={listStatusData.map((status) => ({
            ...status,
            label: renderOption(status.label),
          }))}
          onChange={handleStatusChange}
          onSelect={onSelect}
        />
      </ConfigProvider>
    </div>
  );
};

export default StatusSelect;
